import React  from "react";
import Form from 'react-bootstrap/Form';
import { Rating } from 'react-simple-star-rating'
import PageTitle from "../../Components/PageTitle";




export class Feedback extends React.Component {
    state = {
        selectedOption: null, 
        ratingValue: 0,
    };
    handleChange = (selectedOption) => {
        this.setState({ selectedOption }, () =>
            console.log(`Option selected:`, this.state.selectedOption)
        );
    };


     handleRating = (rate) => {
      this.setState({ratingValue:rate})
    }
    // Catch Rating value
     handleReset = () => {
        this.setState({ratingValue: 4})
      // other logic
    }
  
    render() {
        const { selectedOption } = this.state;

        return (
            <>
             <PageTitle title="Feedback" />
                <section className="feedback_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="feedback_inner">
                                    <h2>
                                        We would like your feedback <br/>to improve our website
                                    </h2>
                                    <div className="feed_back_form">
                                        <form action="">
                                            <div className="row">
                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div className="form-group mb-4">
                                                        <label for="">How much you liked our website?</label>
                                                        <div className="rated">
                                                            <Rating
                                                                onClick={this.handleRating}
                                                                ratingValue={this.state.ratingValue}
                                                                showTooltip={false}
                                                                tooltipDefaultText="ABCD"
                                                                tooltipArray={["0.1", "0.3", "5.7", "7.8", "EXC"]}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <Form.Group className=" mb-4" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Subject</Form.Label>
                                                        <Form.Control type="text" placeholder="Subject" />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Email address</Form.Label>
                                                        <Form.Control type="email" placeholder="name@example.com" />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                        <Form.Group className="mb-4" controlId="exampleForm.ControlTextarea1">
                                                            <Form.Label>Please leave your feedback below</Form.Label>
                                                            <Form.Control as="textarea" rows={3} placeholder="Write your feedback" />
                                                        </Form.Group>
                                                </div>
                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div className="submit_bt float-right ">
                                                        <button type="submit" className="btn-primary_set">Submit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}
export default  Feedback;